// exclusiveViewerStyle.js
'use strict';
import { css } from 'styled-components';

import media from '../style/media.js';
import { color } from '../style/variables.js';

export const EXCLUSIVE_VIEWER_SIZE_TABLET = { width: 124, height: 220 };
export const EXCLUSIVE_VIEWER_SIZE_DESKTOP = { width: 240, height: 135 };

// EXCLUSIVE_VIEWER window absolute position setting
export const EXCLUSIVE_VIEWER_RIGHT = 8;
export const EXCLUSIVE_VIEWER_BOTTOM_WITH_TOP_GIFT = 102;
export const EXCLUSIVE_VIEWER_BOTTOM_WITHOUT_TOP_GIFT = 80;
const EXCLUSIVE_VIEWER_TOP = 60;
export const EXCLUSIVE_VIEWER_FLOAT_Z_INDEX = 4;

// Window look (radius / shadow), single source. Shared by the self window
// and the shrunk streamer player so both small windows always look the same.
export const exclusiveViewerWindowVisualStyle = css`
  border-radius: 4px;
  box-shadow: 0 6px 22px ${color.neutral['0_alpha_80']};
`;

export const exclusiveViewerWindowSizeStyle = css`
  width: ${EXCLUSIVE_VIEWER_SIZE_DESKTOP.width}px;
  height: ${EXCLUSIVE_VIEWER_SIZE_DESKTOP.height}px;
  ${media.tablet`
    width: ${EXCLUSIVE_VIEWER_SIZE_TABLET.width}px;
    height: ${EXCLUSIVE_VIEWER_SIZE_TABLET.height}px;
  `}
`;

// Interact with LiveStream.jsx child components layout setting
export const EXCLUSIVE_VIEWER_WIDTH = EXCLUSIVE_VIEWER_SIZE_TABLET.width;
export const EXCLUSIVE_VIEWER_GAP = 8;
export const EXCLUSIVE_VIEWER_RESERVED_WIDTH =
  EXCLUSIVE_VIEWER_WIDTH + EXCLUSIVE_VIEWER_GAP + EXCLUSIVE_VIEWER_RIGHT;

// Interact with PaidInteractionPanel.jsx (topGift) layout setting
export const getExclusiveViewerWindowBottom = ({ hasTopGift }) =>
  hasTopGift
    ? EXCLUSIVE_VIEWER_BOTTOM_WITH_TOP_GIFT
    : EXCLUSIVE_VIEWER_BOTTOM_WITHOUT_TOP_GIFT;

/**
 * Build the exclusive viewer camera floating window's config for useDraggableFloatingWindow.
 * Only edge margins (size comes from CSS); returns a new object — wrap in useMemo([hasTopGift]).
 * @param {object} params
 * @param {boolean} params.hasTopGift - whether this session has topGift.
 * @returns {object} { margins } for useDraggableFloatingWindow.
 * @example
 * const config = useMemo(() => getExclusiveViewerFloatingConfig({ hasTopGift }), [hasTopGift]);
 */
export const getExclusiveViewerFloatingConfig = ({ hasTopGift }) => ({
  margins: {
    horizontal: EXCLUSIVE_VIEWER_RIGHT,
    top: EXCLUSIVE_VIEWER_TOP,
    bottom: getExclusiveViewerWindowBottom({ hasTopGift }),
  },
});
